//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.17.0.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { localeStore } from '@/store/locale'
import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios'

export class BffClientBase {
  
  constructor() {
  }

  protected transformOptions(options: AxiosRequestConfig) {
    options.headers['Accept-Language'] = localeStore().locale
    return Promise.resolve(options)
  }

  protected transformResult(url: string, response: AxiosResponse<any>, processor: (response: AxiosResponse<any>) => any) {
    const contentType = response.headers['content-type'] as string
    if (contentType && contentType.indexOf('text/html') >= 0) {
      const loc = `${location.protocol}//${location.hostname}:${location.port}`
      if (response.request.responseURL.indexOf(loc) < 0) {
        const unauthorizedError = {
          status: 401,
          statusText: response.request.responseURL,
        }
        throw unauthorizedError
      }
    }
    return processor(response)
  }
}

export interface ISocZekClient {
    /**
     * @param insz (optional) 
     * @return OK
     */
    geefLeefloon_GeefLeefloon(insz?: string | null | undefined): Promise<GeefLeefloonResponse>;
    /**
     * @param insz (optional) 
     * @return OK
     */
    geefSociaalStatuut_GeefSociaalStatuut(data: StatuutDataDto, insz?: string | null | undefined): Promise<GeefSociaalStatuutResponse>;
}

export class SocZekClient extends BffClientBase implements ISocZekClient {
  private instance: AxiosInstance
  private baseUrl: string
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    super()

    this.instance = instance ? instance : axios.create()

    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'https://localhost:48885'
  }

  /**
   * @param insz (optional)
   * @return OK
   */
  geefLeefloon_GeefLeefloon(insz?: string | null | undefined, cancelToken?: CancelToken | undefined): Promise<GeefLeefloonResponse> {
    let url_ = this.baseUrl + '/api/v1/geefleefloon?'
    if (insz !== undefined && insz !== null) url_ += 'insz=' + encodeURIComponent('' + insz) + '&'
    url_ = url_.replace(/[?&]$/, '')

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.instance.request(transformedOptions_)
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGeefLeefloon_GeefLeefloon(_response))
      })
  }

  protected processGeefLeefloon_GeefLeefloon(response: AxiosResponse): Promise<GeefLeefloonResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = resultData200
      return Promise.resolve<GeefLeefloonResponse>(result200)
    } else if (status === 400) {
      const _responseText = response.data
      let result400: any = null
      let resultData400 = _responseText
      result400 = resultData400
      return throwException('Validation errors.', status, _responseText, _headers, result400)
    } else if (status === 404) {
      const _responseText = response.data
      let result404: any = null
      let resultData404 = _responseText
      result404 = resultData404
      return throwException('Not found.', status, _responseText, _headers, result404)
    } else if (status === 401) {
      const _responseText = response.data
      let result401: any = null
      let resultData401 = _responseText
      result401 = resultData401
      return throwException('Not authorized to perform the operation.', status, _responseText, _headers, result401)
    } else if (status === 500) {
      const _responseText = response.data
      let result500: any = null
      let resultData500 = _responseText
      result500 = resultData500
      return throwException('Unexpected error.', status, _responseText, _headers, result500)
    } else if (status === 502) {
      const _responseText = response.data
      let result502: any = null
      let resultData502 = _responseText
      result502 = resultData502
      return throwException('Bad gateway error.', status, _responseText, _headers, result502)
    } else if (status === 403) {
      const _responseText = response.data
      let result403: any = null
      let resultData403 = _responseText
      result403 = resultData403
      return throwException('Insufficient permissions to perform the operation.', status, _responseText, _headers, result403)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException('An unexpected server error occurred.', status, _responseText, _headers)
    }
    return Promise.resolve<GeefLeefloonResponse>(null as any)
  }


    /**
     * @param insz (optional) 
     * @return OK
     */
    geefSociaalStatuut_GeefSociaalStatuut(data: StatuutDataDto, insz?: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<GeefSociaalStatuutResponse> {
        let url_ = this.baseUrl + "/api/v1/geefsociaalstatuut?";
        if (insz !== undefined && insz !== null)
            url_ += "insz=" + encodeURIComponent("" + insz) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGeefSociaalStatuut_GeefSociaalStatuut(_response));
        });
    }

    protected processGeefSociaalStatuut_GeefSociaalStatuut(response: AxiosResponse): Promise<GeefSociaalStatuutResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<GeefSociaalStatuutResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Validation errors.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not found.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = resultData401;
            return throwException("Not authorized to perform the operation.", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500;
            return throwException("Unexpected error.", status, _responseText, _headers, result500);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = resultData502;
            return throwException("Bad gateway error.", status, _responseText, _headers, result502);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403;
            return throwException("Insufficient permissions to perform the operation.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GeefSociaalStatuutResponse>(null as any);
    }
  }

export interface GeefLeefloonResponse {
    advice?: AdviceResponseDto | undefined;
}

export interface AdviceResponseDto {
    advies?: AdviceDto;
    details?: DetailsDto[] | undefined;
}

export interface AdviceDto {
    advice?: AdviesTypeEnum;
    toelichting?: string;
}

export enum AdviesTypeEnum {
  OK = 'OK',
  VA = 'VA',
  DNK = 'DNK',
  NOK = 'NOK',
}

export interface DetailsDto {
    beschrijving?: string;
    code?: string;
    resultaat?: string;
}

export interface ErrorMessage {
  type?: string | undefined
  title: string
  status?: number
  detail: string
  instance?: string | undefined
}

export interface GeefSociaalStatuutResponse {
    socialStatesPerson?: PersoonDto;
    warnings?: MagdaError[];
}

export interface PersoonDto {
    insz?: string;
    socialStates?: StatuutDto[];
}

export interface StatuutDto {
    name?: string;
    result?: CodeOmschrijvingDto;
    periods?: PeriodeDto[];
    status?: StatusDto;
    details?: DetailDto[];
}

export interface CodeOmschrijvingDto {
    code?: string;
    description?: string;
}

export interface PeriodeDto {
    startDate?: Date | undefined;
    endDate?: Date | undefined;
}

export interface StatusDto {
    code?: string;
    description?: string;
    value?: string;
}

export interface DetailDto {
    name?: string;
    value?: string;
}

export interface MagdaError {
    message: string | undefined;
    description?: string | undefined;
    externalCode?: string | undefined;
    type?: MagdaErrorType;
}

export enum MagdaErrorType {
    Error = "Error",
    Warning = "Warning",
    Information = "Information",
}

export interface StatuutDataDto {
    purposes?: PurposeDto[];
}

export interface PurposeDto {
    name?: string;
    dateChoice?: DateChoiceEnum;
    fromDate?: Date;
    toDate?: Date | undefined;
    location?: string;
}

export enum DateChoiceEnum {
    On = "On",
    Period = "Period",
}

export class ApiException extends Error {
  message: string
  status: number
  response: string
  headers: { [key: string]: any }
  result: any

  constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
    super()

    this.message = message
    this.status = status
    this.response = response
    this.headers = headers
    this.result = result
  }

  protected isApiException = true

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true
  }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any }, result?: any): any {
  throw new ApiException(message, status, response, headers, result)
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
  return obj && obj.isAxiosError === true
}
